import { render, staticRenderFns } from "./CreateFilter.vue?vue&type=template&id=04be23b5"
import script from "./CreateFilter.vue?vue&type=script&lang=js"
export * from "./CreateFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports